// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3DdOh","mask":"mask--2e68x","title":"title--2-mHJ","content":"content--2lR6F","close":"close--3qq3k"};